import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { checkConsultantHabilitation } from 'projects/box-lib/src/lib/utils/habilitation';
import { Operation, PresettedProduit } from 'projects/box-lib/src/lib/models/generated/graphql';

@Component({
    selector: 'lib-consultant-cell',
    templateUrl: './consultant-cell.component.html',
    styleUrls: ['./consultant-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ConsultantCellComponent {
  @Input() operation: Operation;
  @Input() displayName: string | undefined | null;
  constructor() {}
  // displayColumnInfo(column: OperationDashboardColumn, operation: Operation) {
  //   return column.getDataFromOperation(operation, this.currencyPipe, this.datePipe);
  // }

  isOperationConsultantHabilited(operation: Operation): boolean {
    return checkConsultantHabilitation(
      operation.produitPreset?.habilitationCode,
      operation.consultantPreset?.habilitationCodes ?? []
    );
  }

  habilitationToolTipText(produitPreset: PresettedProduit | null): string {
    if (produitPreset?.habilitationLibelle) {
      return `Habilitation ${produitPreset.habilitationLibelle} inactive`;
    }
    return 'Habilitation inactive';
  }
}
